import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {SectionModel} from '@app/models/section';
import Section = SectionModel.Section;
import Card = SectionModel.Card;
import {findIndex, indexOf} from 'lodash-es';
import {FormGroup} from '@angular/forms';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {formly} from '@shared/helper/formly-helpers';


@Component({
    selector: 'app-banner-editor',
    templateUrl: './banner-editor.component.html',
    styleUrls: ['./banner-editor.component.css']
})
export class BannerEditorComponent implements OnInit {
    @Input() section: Section;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onSave = new EventEmitter<Section>();

    formGroup = new FormGroup({});

    fields: FormlyFieldConfig[] = [
        formly.text('imageUrl', 'Image Url'),
        formly.text('title', 'Title'),
        formly.text('subtitle', 'Subtitle'),
        formly.text('route', 'Route'),
        formly.boolean('active', 'Active'),
    ];

    displayEditCard = false;
    editCard: Card;

    constructor() {
    }

    ngOnInit() {
    }

    submit() {
    }

    add() {
        this.openEditDialog({imageUrl: '', type: 'BANNER'});
    }

    openEditDialog(card: Card) {
        card.id = Date.now().toString();
        this.displayEditCard = true;
        this.editCard = {...card};
    }

    closeEditDialog() {
        const index = findIndex(this.section.cards, (c) => c.id === this.editCard.id);
        if (index !== -1){
            this.section.cards[index] = this.editCard;
        }else {
            this.section.cards.push(this.editCard);
        }

        this.section.cards = [...this.section.cards];

        this.displayEditCard = false;
        this.editCard = undefined;
    }

    delete(card: Card) {
        this.displayEditCard = false;
        this.section.cards = this.section.cards.filter(c => c.imageUrl !== card.imageUrl);
    }

    closeDialog() {
        this.onSave.emit(this.section);
    }
}
